/**
 * OfflineIndicator - Migrated to Tailwind CSS
 */
import { useState, useEffect } from 'react';

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div
      className={`
        fixed bottom-0 left-0 right-0 py-3 px-4
        text-center text-sm z-[9999]
        animate-[slideUp_0.3s_ease-out]
        ${
          isOnline
            ? 'bg-gradient-to-br from-emerald-500 to-emerald-600 text-white'
            : 'bg-gradient-to-br from-amber-400 to-amber-500 text-gray-900'
        }
      `}
    >
      {isOnline ? (
        <span>✓ ಆನ್‌ಲೈನ್‌ಗೆ ಮರಳಿದ್ದೀರಿ (Back online)</span>
      ) : (
        <span>
          ⚡ ಆಫ್‌ಲೈನ್ ಮೋಡ್ - ಕ್ಯಾಶ್ ಮಾಡಿದ ಸುತ್ತಗಳು ಲಭ್ಯವಿದೆ (Offline mode - cached suttas available)
        </span>
      )}
    </div>
  );
}

export default OfflineIndicator;
